import Link from 'next-intl/link';
import { IoMdPhotos } from 'react-icons/io';
import Card from './Card';
import { useLocaleRoutes } from '../utils/useLocaleRoutes';
import { useTranslations } from 'next-intl';
import MarkAsReadyButton from './MarkAsReadyButton';
import AdminEditButton from './AdminEditButton';
import { getCookie } from 'cookies-next';

export default function Grid({
  items = [],
  editLink = false,
  rows = false,
}: {
  items: any[];
  editLink?: boolean;
  rows?: number | false;
}) {
  const path = useLocaleRoutes();
  const t = useTranslations('newAd');
  const showEditButton = getCookie('adminEditButtons');
  return (
    <ul className='grid grid-cols-2 gap-x-4 gap-y-6 sm:gap-x-8 lg:grid-cols-3 lgc:grid-cols-5'>
      {items.map((item: any, i: number) => {
        let className = '';
        if (rows) {
          const offset = rows;
          className +=
            i >= 2 * offset && i < 4 * offset ? 'hidden lg:block' : '';
          className += i >= 4 * offset ? 'hidden lgc:block' : '';
        }
        if (editLink && showEditButton) {
          className += ' pb-48';
        } else if (editLink) {
          className += ' pb-32';
        } else if (showEditButton) {
          className += ' pb-12';
        }
        return (
          <li key={i} className={className}>
            <Card item={item} />
            {editLink && (
              <>
                <Link
                  href={`/${path('edit-item')}/${item.id}`}
                  className='mt-2 flex items-center justify-center gap-2 rounded-sm bg-brand px-6 py-4 font-semibold uppercase text-black hover:bg-white focus:bg-white'
                >
                  <IoMdPhotos /> <span>{t('addPhotos')}</span>
                </Link>
                <MarkAsReadyButton item={item} />
              </>
            )}
            <AdminEditButton id={parseInt(item.id)} />
          </li>
        );
      })}
    </ul>
  );
}
